import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/icons/info-circle-solid.svg'
import _imports_1 from './../assets/icons/phone-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-02968808"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column px-4 pb-4"
}
const _hoisted_2 = { class: "title mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "info-icon",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "phone-icon",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.title && _ctx.content)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
            : _createCommentVNode("", true),
          (_ctx.infoIcon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                title: _ctx.infoIcon
              }, _hoisted_6, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.capitalize ? 'content capitalize' : 'content')
        }, [
          (!_ctx.isPhone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.content), 1))
            : _createCommentVNode("", true),
          (_ctx.isPhone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: 'tel:' + _ctx.content
              }, [
                _createTextVNode(_toDisplayString(_ctx.content) + " ", 1),
                _hoisted_9
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}